import { get } from 'lodash';
import React from 'react';
import { Field, FieldProps, FieldValidator } from 'formik';

import { useRegisteredRef } from 'src/lib/react-register-nodes';
import { FileUploader, FileUploaderProps } from '../FileUploader';
import { FormikErrorMessage } from './FormikErrorMessage';

type FormikFileUploaderProps = { name: string } & Optional<FileUploaderProps, 'onChange' | 'onRemoveFile'> & {
    validate?: FieldValidator;
  };

const FormikFileUploader = ({ name, validate = null, onChange, fileNames, ...rest }: FormikFileUploaderProps) => {
  const ref = useRegisteredRef(name);
  return (
    <Field name={name} {...(validate ? { validate } : {})}>
      {({ field: { value }, form: { setFieldValue, touched, errors } }: FieldProps) => {
        const error = get(touched, name) && get(errors, name);
        const currentFileNames =
          value !== undefined && typeof value?.get === 'function'
            ? [value?.get('fileName')].filter(Boolean)
            : fileNames;
        return (
          <FileUploader
            name={name}
            fileNames={currentFileNames}
            onChange={file => (typeof onChange === 'function' ? onChange(file) : setFieldValue(name, file))}
            onRemoveFile={() => setFieldValue(name, null)}
            ref={error ? ref : undefined}
            error={Boolean(error)}
            {...rest}
          >
            <FormikErrorMessage name={name} />
          </FileUploader>
        );
      }}
    </Field>
  );
};

export default FormikFileUploader;
